import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { AUTH_COLORS, AUTH_FONT, AUTH_SOCIAL } from "../../config/authConstants";
import iconLinkedin from "../../Assests/Images/auth/icon-linkedin.svg";
import iconYoutube from "../../Assests/Images/auth/icon-youtube.svg";
import iconInstagram from "../../Assests/Images/auth/icon-instagram.svg";
import iconFacebook from "../../Assests/Images/auth/icon-facebook.svg";
import iconX from "../../Assests/Images/auth/icon-x.svg";
import arrowUpRight from "../../Assests/Images/auth/arrow-up-right.svg";

var SOCIAL_ICONS = {
  linkedin: iconLinkedin,
  youtube: iconYoutube,
  instagram: iconInstagram,
  facebook: iconFacebook,
  x: iconX,
};

function AuthFollowUs() {
  return (
    <Box
      component="aside"
      aria-label="Follow Us"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 2,
        p: 2,
        bgcolor: AUTH_COLORS.surface,
        border: "1px solid " + AUTH_COLORS.border,
        borderRadius: "12px",
        flexShrink: 0,
        width: { xs: "100%", md: "auto" },
        maxWidth: { xs: 360, md: "none" },
        boxSizing: "border-box",
      }}
    >
      <Typography
        component="h2"
        sx={{
          m: 0,
          fontFamily: AUTH_FONT,
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 1.2,
          color: AUTH_COLORS.text,
        }}
      >
        Follow Us:
      </Typography>

      <Stack spacing={1.25} sx={{ width: { xs: "100%", md: 140 } }}>
        {AUTH_SOCIAL.map(function (item) {
          return (
            <Link
              key={item.id}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
                color: AUTH_COLORS.textSecondary,
                "&:hover .auth-social-label": {
                  color: AUTH_COLORS.text,
                },
              }}
            >
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "8px",
                  border: "1px solid " + AUTH_COLORS.borderSecondary,
                  bgcolor: AUTH_COLORS.surface,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxSizing: "border-box",
                }}
              >
                <Box
                  component="img"
                  src={SOCIAL_ICONS[item.id]}
                  alt=""
                  sx={{
                    width: 14.4,
                    height: 14.4,
                    display: "block",
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography
                className="auth-social-label"
                component="span"
                sx={{
                  flex: 1,
                  minWidth: 0,
                  fontFamily: AUTH_FONT,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: 1.2,
                  color: AUTH_COLORS.textSecondary,
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </Typography>
              <Box
                component="img"
                src={arrowUpRight}
                alt=""
                sx={{ width: 16, height: 16, display: "block", flexShrink: 0 }}
              />
            </Link>
          );
        })}
      </Stack>
    </Box>
  );
}

export default AuthFollowUs;
